import Dragdealer from 'dragdealer';

export default function onlyMobileSliderInit() {
  let el = document.getElementById('onlymobile-slider'),
      maskEl = document.querySelector('.partners-slider-container'),
      bodyEl = document.querySelector('.partners'),
      availHeight = bodyEl.offsetWidth - maskEl.offsetWidth;

  let scr = new Dragdealer(el, {
    horizontal: true,
    vertical: false,
    yPrecision: availHeight,
    animationCallback: function(x, y) {
      bodyEl.style.transform = 'translateX(' + (-x * availHeight) + 'px)';
    }
  });
}



// WEBPACK FOOTER //
// ./src/js/mobile-slider.js